import { render, staticRenderFns } from "./ChipCollapse.vue?vue&type=template&id=783fa806&scoped=true&"
import script from "./ChipCollapse.vue?vue&type=script&lang=js&"
export * from "./ChipCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ChipCollapse.vue?vue&type=style&index=0&id=783fa806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783fa806",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
